/**
 * ForbiddenPage – 403 stranica za zaštićene rute (npr. ProtectedRoute kada korisnik nije prijavljen)
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { EkonsultacijeButton } from '../ui/Button';
import { EkonsultacijeCard, EkonsultacijeCardContent } from '../ui/Card';
import { usePageTitle } from '../../context/PageTitleContext';
import './ErrorPage.css';
import './ForbiddenPage.css';

// ---------- Komponenta ----------
const ForbiddenPage = ({ onLogin }) => {
  const navigate = useNavigate();
  const { updateTitle } = usePageTitle();

  useEffect(() => {
    updateTitle('Приступ одбијен - ОГП Портал', 'Приступ одбијен');
  }, [updateTitle]);

  // ---------- Rukovaoci ----------
  const handleGoHome = () => {
    navigate('/');
  };

  const handleLogin = () => {
    if (onLogin) {
      onLogin();
    } else {
      navigate('/');
    }
  };

  // ---------- Render ----------
  return (
    <div className="error-page forbidden-page">
      <div className="container-fluid">
        <div className="error-page-content">
          <EkonsultacijeCard className="error-card">
            <EkonsultacijeCardContent>
              <div className="error-content">
                <div className="error-code">403</div>
                <h1 className="error-title">Приступ одбијен</h1>
                <p className="error-message">
                  Морате да се пријавите како бисте приступили овој страници.
                </p>
                <div className="error-actions">
                  <EkonsultacijeButton
                    variant="primary"
                    size="lg"
                    onClick={handleGoHome}
                    className="error-button"
                  >
                    Назад на почетну
                  </EkonsultacijeButton>
                  <EkonsultacijeButton
                    variant="primary"
                    size="lg"
                    onClick={handleLogin}
                    className="error-button"
                  >
                    Пријави се
                  </EkonsultacijeButton>
                </div>
              </div>
            </EkonsultacijeCardContent>
          </EkonsultacijeCard>
        </div>
      </div>
    </div>
  );
};

export default ForbiddenPage;

